import styled from "styled-components";

export const Icon = styled.svg`
    path {
        fill: ${(props) => props.color};
    }

    &:hover {
        path {
            fill: ${(props) => (props.hover ? props.hoverColor : props.color)};
        }
    }
`;
